export const GET_CAREER_TITLES = 'GET_CAREER_TITLES';
export const GET_CAREER_TITLE_BY_ID = 'GET_CAREER_TITLE_BY_ID';
export const UPDATE_CAREER_TITLE = 'UPDATE_CAREER_TITLE';
export const DELETE_CAREER_TITLE = 'DELETE_CAREER_TITLE';
export const CREATE_CAREER_TITLE = 'CREATE_CAREER_TITLE';
